<template>
  <a-modal
    :open="open"
    :title="mode === 'change' ? '号牌变更' : '号牌绑定'"
    :confirm-loading="submitLoading"
    width="520px"
    @ok="handleSubmit"
    @cancel="handleClose"
  >
    <a-form ref="formRef" :model="formData" :rules="rules" layout="vertical">
      <a-form-item label="号牌号码" name="licenceNo">
        <a-input
          v-model:value="formData.licenceNo"
          placeholder="请输入号牌号码"
          :maxlength="30"
        />
      </a-form-item>
      <a-form-item label="生效日期" name="startDate">
        <a-date-picker
          v-model:value="formData.startDate"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          style="width: 100%"
          placeholder="请选择生效日期"
        />
      </a-form-item>
      <a-form-item label="失效日期" name="endDate">
        <a-date-picker
          v-model:value="formData.endDate"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          style="width: 100%"
          placeholder="请选择失效日期"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref, reactive, watch } from "vue";
import { message } from "ant-design-vue";
import { bindVehicleLicence } from "@/api/vehicle";

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  // bind: 号牌绑定 / change: 号牌变更
  mode: {
    type: String,
    default: "bind",
  },
  // 当前车辆 { id, licenceNo }
  vehicle: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:open", "success"]);

const formRef = ref();
const submitLoading = ref(false);

const formData = reactive({
  licenceNo: "",
  startDate: undefined,
  endDate: undefined,
});

const rules = {
  licenceNo: [
    { required: true, message: "请输入号牌号码", trigger: "blur" },
  ],
  startDate: [
    { required: true, message: "请选择生效日期", trigger: "change" },
  ],
  endDate: [
    { required: true, message: "请选择失效日期", trigger: "change" },
    {
      validator: () => {
        if (
          formData.startDate &&
          formData.endDate &&
          formData.endDate < formData.startDate
        ) {
          return Promise.reject("失效日期不能早于生效日期");
        }
        return Promise.resolve();
      },
      trigger: "change",
    },
  ],
};

// 弹窗打开时重置表单；变更模式下回显当前号牌
watch(
  () => props.open,
  (val) => {
    if (val) {
      formData.licenceNo =
        props.mode === "change" ? props.vehicle?.licenceNo || "" : "";
      formData.startDate = undefined;
      formData.endDate = undefined;
      formRef.value?.clearValidate();
    }
  }
);

const handleSubmit = async () => {
  try {
    await formRef.value.validate();
  } catch (e) {
    return;
  }

  submitLoading.value = true;
  try {
    const res = await bindVehicleLicence({
      vehicleId: props.vehicle?.id,
      licenceNo: formData.licenceNo,
      startDate: formData.startDate,
      endDate: formData.endDate,
    });
    if (res.code === 200) {
      message.success(props.mode === "change" ? "号牌变更成功" : "号牌绑定成功");
      emit("update:open", false);
      emit("success");
    } else {
      message.error(res.msg || "提交失败");
    }
  } catch (error) {
    console.error("号牌绑定失败:", error);
    message.error("提交失败");
  } finally {
    submitLoading.value = false;
  }
};

const handleClose = () => {
  emit("update:open", false);
};
</script>
